import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateRepairEstimateDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRepairEstimateControllerGetParamsGen,
  MrfiktivRepairEstimateViewModelGen,
  MrfiktivUpdateRepairEstimateDtoGen
} from "../v1/data-contracts";
import { RepairEstimate } from "../v1/RepairEstimate";

/**
 * Communicate with RepairEstimate API
 */
class RepairEstimateService {
  mrfiktivProxy: RepairEstimate;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new RepairEstimate(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create anRepairEstimate
   */
  async create(
    partnerId: string,
    data: MrfiktivCreateRepairEstimateDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const repairEstimate = (await this.mrfiktivProxy.repairEstimateControllerCreate(partnerId, data)).data;

    return repairEstimate;
  }

  /**
   * Get allRepairEstimate
   */
  async get(
    data: MrfiktivRepairEstimateControllerGetParamsGen
  ): Promise<
    MrfiktivPageViewModelGen & {
      data?: MrfiktivRepairEstimateViewModelGen[];
    }
  > {
    const repairEstimates = (await this.mrfiktivProxy.repairEstimateControllerGet(data)).data;

    return repairEstimates;
  }

  /**
   * Get a RepairEstimate
   */
  async getOne(partnerId: string, repairEstimateId: string): Promise<MrfiktivRepairEstimateViewModelGen> {
    const repairEstimate = (await this.mrfiktivProxy.repairEstimateControllerGetOne(partnerId, repairEstimateId)).data;

    return repairEstimate;
  }

  /**
   * Update a RepairEstimate
   */
  async update(
    partnerId: string,
    repairEstimateId: string,
    data: MrfiktivUpdateRepairEstimateDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const repairEstimate = (await this.mrfiktivProxy.repairEstimateControllerUpdate(partnerId, repairEstimateId, data))
      .data;

    return repairEstimate;
  }

  /**
   * Accept a RepairEstimate as partner
   * @param partnerId
   * @param repairEstimateId
   * @param token
   * @returns
   */
  async updateStatus(
    partnerId: string,
    repairEstimateId: string,
    status: RequestStatusEnum
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateControllerUpdateStatus(partnerId, repairEstimateId, {
      status
    });

    return shared.data;
  }

  /**
   * Delete a RepairEstimate
   */
  async delete(partnerId: string, repairEstimateId: string): Promise<MrfiktivRepairEstimateViewModelGen> {
    const repairEstimate = (await this.mrfiktivProxy.repairEstimateControllerDelete(partnerId, repairEstimateId)).data;

    return repairEstimate;
  }
}

/**
 * Communicate with RepairEstimate API
 */
export default new RepairEstimateService(new MrfiktivHttpClientProvider());
